<script>
import _ from 'lodash'
export default {
	lang: 'books',
	inject: ['editor'],
	data() {
		return {
			tabIndex: -1,
		}
	},
	computed: {
		e() {
			return this.editor()
		},
		tabs() {
			const data = this.e.customization.data
			const files = this.e.customizationFiles
			const { $lang } = this
			const config = this.e.config
			return [
				{
					title: config.box1Title,
					get value() {
						return data.name
					},
					incompleteValue: $lang('Completa los datos'),
					get complete() {
						return data.name && data.coverId && data.sheetTypeId
					},
				},
				{
					title: config.box2Title,
					get value() {
						// if (data.useDefaultUserImage) {
						// 	return $lang('Foto predeterminada')
						// } else {
						let str = $lang('Tu foto')
						return `${str} (${data.userImageName})`
						// }
					},
					incompleteValue: $lang('Agrega una foto'),
					get complete() {
						// return data.useDefaultUserImage || files.userImage || data.userImage
						return files.userImage || data.userImage
					},
				},
			]
		},
		dataChecker() {
			let data = this.e.customization.data
			let files = this.e.customizationFiles
			let checker = _.pick(data, ['name', 'coverId', 'sheetTypeId'])
			// checker.userImage = [!!data.useDefaultUserImage, !!files.userImage, !!data.userImage]
			checker.userImage = [!!files.userImage, !!data.userImage]
			return JSON.stringify(checker)
		},
	},
}
</script>

<template>
	<BookEditor-Tabs :tabs="tabs" :data-checker="dataChecker" v-model="tabIndex">
		<template #item1>
			<div>
				<div class="d-flex w100 flex-column flex-md-row justify-center pb-6" style="gap: 42px">
					<BookEditorInput-ImagesOptionsSelector
						data-key="coverId"
						:title="$lang('Elige la Tapa')"
						:options="
							e.config.covers.map((c) => ({
								value: c.coverId,
								label: $lang(c.name),
								img: c.img,
							}))
						"
					/>
					<BookEditorInput-ImagesOptionsSelector
						data-key="sheetTypeId"
						:title="$lang('Elige el Tipo de Hojas')"
						:options="
							e.config.sheetTypes.map((c) => ({
								value: c.typeId,
								label: $lang(c.name),
								img: c.img,
							}))
						"
					/>
				</div>
				<div>
					<BookEditorInput-TextField
						model-key="name"
						:label="$lang('Para')"
						:placeholder="$lang('Nombre')"
					/>
				</div>
			</div>
		</template>
		<template #item2>
			<BookEditorTab-UserImage />
		</template>
	</BookEditor-Tabs>
</template>
